import { Train, Building2, Bus, Plane, MapPin, ExternalLink } from "lucide-react";
import { DISTANCES, BRAND } from "@/mock";

const ICONS = { Train, Building2, Bus, Plane };

const DistanceStrip = () => {
  return (
    <section
      id="location"
      className="bg-[#1A1A1A] py-6 px-5 md:px-10 border-b border-[#C8A97E]/15"
      data-testid="distance-strip"
    >
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-stretch lg:items-center gap-4">
        <div className="flex items-center gap-2 text-[#C8A97E]">
          <MapPin className="w-4 h-4" />
          <span className="text-[10px] tracking-[0.22em] uppercase font-semibold whitespace-nowrap">
            Distance from us
          </span>
        </div>

        <div className="flex-1 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-0">
          {DISTANCES.map((d, i) => {
            const Icon = ICONS[d.icon] || MapPin;
            return (
              <a
                key={d.key}
                href={`https://maps.google.com/?q=${d.maps}`}
                target="_blank"
                rel="noopener noreferrer"
                className={`flex items-center gap-3 px-4 py-2 hover:bg-white/5 transition-colors ${
                  i !== DISTANCES.length - 1 ? "lg:border-r border-white/10" : ""
                }`}
                data-testid={`distance-${d.key}`}
              >
                <Icon className="w-5 h-5 text-[#C8A97E] flex-shrink-0" strokeWidth={1.5} />
                <div>
                  <div className="font-serif text-[20px] font-semibold text-[#C8A97E] leading-none">
                    {d.km} <span className="text-[10px] text-white/50 font-sans font-medium ml-0.5">km</span>
                  </div>
                  <div className="text-[11px] text-white/70 leading-tight mt-1">
                    {d.name}
                    <br />
                    <span className="text-white/45">{d.sub}</span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        <a
          href={`https://maps.google.com/?q=${BRAND.mapsQuery}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 bg-[#C8A97E] hover:bg-[#B0946B] text-[#1A1A1A] rounded-full px-5 py-2.5 text-[12px] font-semibold transition-all whitespace-nowrap"
          data-testid="open-google-maps-btn"
        >
          <ExternalLink className="w-3.5 h-3.5" /> Open Google Maps
        </a>
      </div>
    </section>
  );
};

export default DistanceStrip;
